<template>
    <div></div>
</template>

<script>
    export default {
        name: "Logout",
        mounted() {
            location.href = localStorage.getItem("keycloak-logout-url");
        }
    }
</script>

<style scoped>

</style>